export let quality = "MD";

export const ArtworksCollection = [
    {
        name: "Ora blu sottto al Pelmo",
        description: "Ora blu invernale sotto al Pelmo, Dolomiti.",
        position: { x: 0.245, y: 1.729, z: -3.569 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato destro, a destra
        size: 2.37,
        url: "IMG_2368.jpg",
        author: "Elia Lazzari",
        year: 2017,
        redirectUrl: "https://www.eliusoutdoor.com/dolomites-nights"
    },
    {
        name: "Il faro delle Dolomiti",
        description: "Incantevole scenario notturno sulle Dolomiti, mare di nuvole, cielo stellato e la luna che illuminano la valle di Agordo, Dolomiti.",
        position: { x: -2.784, y: 1.729, z: -3.569 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato destro, a sinistra
        size: 2.37,
        url: "DSC00486.jpg",
        author: "Elia Lazzari",
        year: 2022,
        redirectUrl: "https://www.eliusoutdoor.com/dolomites-nights"
    },
    {
        name: "Luna nascente sulla torre Valgrande",
        description: "Era il primo giorno dell'anno, e la luna era appena sorta. La luce della luna illuminava la torre Valgrande, Dolomiti, Val di Zoldo.",
        position: { x: -4.645, y: 1.689, z: -2.09 },
        rotation: { x: -31.415, y: -39.278, z: 50.269 }, // piano terra facciata centrale, a destra
        size: 1.35,
        url: "DSC02687.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/dolomites-nights"
    },
    {
        name: "La Luna e il mare appenninico",
        description: "Una caldissima luna piena ci ha accompagnato durante una notte di trekking in Appennino. La luna illuminava le shilouette delle colline appendiniche, facendole sembrare un mare azzurro.",
        position: { x: -4.645, y: 1.689, z: 0.71 },
        rotation: { x: -31.415, y: -39.278, z: 50.269 }, // piano terra facciata centrale, a sinistra
        size: 1.35,
        url: "DSC00675-Edit.jpg",
        author: "Elia Lazzari",
        year: 2022,
        redirectUrl: "https://www.eliusoutdoor.com/wild-appennino"
    },
    {
        name: "Luna nascente sul Cadore",
        description: "La luna piena si alza sulle Dolomiti, illuminando il Cadore.",
        position: { x: -2.784, y: 1.63, z: 2.371 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato sinistro, a destra
        size: 2.37,
        url: "DSC02880-HDR.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/dolomites-nights"
    },
    {
        name: "Tramonto norvegese",
        description: "Tramonto sulle montagne norvegesi, durante il nostro viaggio in tenda nelle isole Lofoten.",
        position: { x: 0.245, y: 1.63, z: 2.371 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato sinistro, a sinistra
        size: 2.37,
        url: "EL_00492.jpg",
        author: "Elia Lazzari",
        year: 2019,
        redirectUrl: "https://www.eliusoutdoor.com/lofoten-adventure-2019"
    },
    {
        name: "Via lattea sulla val di Zoldo",
        description: "Una bella notte di mezza estate, con la via lattea che si staglia sulle Dolomiti della Val di Zoldo.",
        position: { x: -2.799, y: 5.589, z: -0.629 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata destra, più lontana
        size: 1.225,
        url: "DSC01300-Enhanced-NR.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/dolomites-nights"
    },
    {
        name: "Via lattea sulla Marmolada",
        description: "Il mio primo scatto alla via lattea, realizzato nei pressi del Passo Giau",
        position: { x: -0.120, y: 5.589, z: -0.629 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata destra, più vicina
        size: 1.225,
        url: "EL_05089.jpg",
        author: "Elia Lazzari",
        year: 2017,
        redirectUrl: "https://www.eliusoutdoor.com/dolomites-nights"
    },
    {
        name: "Via lattea sul monte Cernera",
        description: "Scatto realizzato dalle colline attorno al Passo Giau, Dolomiti.",
        position: { x: -0.12, y: 5.589, z: -0.584 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata sinistra, più vicina
        size: 1.225,
        url: "EL_07235-Modifica-2.jpg",
        author: "Elia Lazzari",
        year: 2020,
        redirectUrl: "https://www.eliusoutdoor.com/dolomites-nights"
    },
    {
        name: "La luna riposa su un soffice cuscino di nuvole",
        description: "Quiete e pace in una notte di mezza estate, con la luna che riposa su un soffice cuscino di nuvole. Sull'orizzonte si staglia la Marmolada. Noi eravamo sulla cima del Civetta e non potevamo sapere che poche ore dopo si sarebbe staccato un pezzo di montagna, che avrebbe causato una frana di proporzioni epiche.",
        position: { x: -2.799, y: 5.589, z: -0.589 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata sinistra, più lontana
        size: 1.225,
        url: "DSC09646.jpg",
        author: "Elia Lazzari",
        year: 2022,
        redirectUrl: "https://www.eliusoutdoor.com/dolomites-nights"
    },
];
export default ArtworksCollection;